import { Link } from 'react-router-dom';
import { heroArticles } from '@/mocks/home';

export default function HeroSection() {
  const mainArticle = heroArticles[0];

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={mainArticle.image}
          alt="51黑料网 - 最新黑料曝光"
          className="w-full h-full object-cover object-top"
          title="51黑料网 - 2026年度黑料曝光平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          {/* Badge */}
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-xs font-medium mb-6">
            <i className="ri-flashlight-line text-sm"></i>
            独家爆料
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight">
            {mainArticle.title}
          </h1>

          <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-300 leading-relaxed max-w-2xl mx-auto">
            {mainArticle.excerpt}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-7">
            <Link
              to={`/article/${mainArticle.slug}`}
              className="px-7 py-3 bg-primary-500 text-foreground-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              阅读全文
              <i className="ri-arrow-right-line"></i>
            </Link>
            <span className="flex items-center gap-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {mainArticle.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {mainArticle.views.toLocaleString()}
              </span>
            </span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-xs text-foreground-500">向下滚动</span>
        <i className="ri-arrow-down-line text-foreground-500 animate-bounce"></i>
      </div>
    </section>
  );
}
